import { Compass } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { AppShell } from "@/components/layout/AppShell";
import { BrandButton } from "@/components/kit/BrandButton";
import { EmptyState } from "@/components/kit/EmptyState";
import { PAGES } from "@/constants/testIds";

export default function NotFound() {
  const navigate = useNavigate();
  return (
    <AppShell title="Not found" showBack={false} size="reading">
      <div data-testid={PAGES.notFound} className="contents">
        <EmptyState icon={Compass} title="This page doesn't exist" description="Let's get you back on track.">
          <BrandButton name="notfound-library" onClick={() => navigate("/library")}>
            Go to my programs
          </BrandButton>
        </EmptyState>
      </div>
    </AppShell>
  );
}
